import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from '../core/services/api.service';

export interface WeatherData {
    time: string;
    condition: string;
    icon: string;
    temperature: string;
    precipitation: string;
    humidity: string;
    wind: string;
}

@Injectable({
    providedIn: 'root'
})
export class WeatherService {
    constructor(private apiService: ApiService) { }

    /**
     * Get weather data using project location priority:
     * latitude/longitude -> zip -> city/state
     */
    getWeatherData(location: {
        city?: string;
        state?: string;
        zip?: string;
        latitude?: string;
        longitude?: string;
    }, date: Date): Observable<WeatherData[]> {
        const dateStr = this.formatDate(date);
        const queryParams = new URLSearchParams({
            date: dateStr
        });

        if (location.city) {
            queryParams.set('city', location.city);
        }
        if (location.state) {
            queryParams.set('state', location.state);
        }
        if (location.zip) {
            queryParams.set('zip', location.zip);
        }
        if (location.latitude) {
            queryParams.set('latitude', location.latitude);
        }
        if (location.longitude) {
            queryParams.set('longitude', location.longitude);
        }

        return this.apiService.get(
            `Weather/GetWeatherData?${queryParams.toString()}`
        ).pipe(
            catchError(error => {
                console.error('Error fetching weather data:', error);
                return of([]);
            })
        );
    }

    /**
     * Format date to YYYY-MM-DD format
     */
    private formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
}
